import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Organisation, OrganisationControllerService} from "../../../../api";
import {Subject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-organisationList-popup',
    templateUrl: './organisation-popup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./organisation-popup.component.scss'],

})
export class OrganisationPopupComponent implements OnInit {
  data = inject<{
    organisationId: number;
    title: string;
  }>(MAT_DIALOG_DATA);
  private organisationControllerService = inject(OrganisationControllerService);
  private dialogRef = inject<MatDialogRef<OrganisationPopupComponent>>(MatDialogRef);


  organisation!: Organisation | undefined;
  title!: string;

  organisationChangedEvent: Subject<Organisation> = new Subject<Organisation>();
  clearEvent: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    if(this.data.title){
      this.title = this.data.title;
    }else{
      this.title = "Unternehmenseinstellungen";
    }
    this.organisationControllerService.getOrganisation(this.data.organisationId).subscribe((data) => {
      this.organisation = data;
      this.organisationChangedEvent.next(this.organisation);
    });
  }

  close(){
    this.dialogRef.close();
  }

}
